import { useState } from 'react'
import type { ReactElement } from 'react'
import type { Workspace } from '../../types/workspace'
import { OnboardingGate } from './OnboardingGate'

type UseCreateWorkspaceOnboardingOptions = {
  canCreate: boolean
  onWorkspaceReady?: (workspace: Workspace) => void
}

type UseCreateWorkspaceOnboardingResult = {
  open: () => void
  gate: ReactElement | null
}

export function useCreateWorkspaceOnboarding({
  canCreate,
  onWorkspaceReady,
}: UseCreateWorkspaceOnboardingOptions): UseCreateWorkspaceOnboardingResult {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => {
    if (!canCreate) return
    setIsOpen(true)
  }

  const close = () => setIsOpen(false)

  const gate = isOpen ? (
    <OnboardingGate
      isSwitching
      onCancel={close}
      onWorkspaceReady={(ws) => {
        close()
        onWorkspaceReady?.(ws)
      }}
    />
  ) : null

  return { open, gate }
}
